import { CITIES_URL_V2, CITY_BY_IP_URL_V2 } from '@alfa-bank/site-envconfig';

export const citiesEndPoint = CITIES_URL_V2();
export const cityByIPEndPoint = CITY_BY_IP_URL_V2();
